export default __webpack_public_path__ + "static/media/Plant.18984249.png";